import { render } from "./SignUp.vue?vue&type=template&id=c21b3f8c&scoped=true&ts=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"

import "./SignUp.vue?vue&type=style&index=0&id=c21b3f8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21b3f8c"]])

export default __exports__